import { Button } from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';

const Styled = styled.div`
  background: #fff;
  padding: 8px 16px;
  margin: 0;
`;

const ButtonStyled = styled(Button)`
  background: none;
  border: none;
  box-shadow: none;
  margin: 0;
  font-weight: bold;
  color: #869096;
  font-size: 16px;
  text-shadow: none;
  border-radius: 0;
  position: relative;
  padding: 0;
  margin-right: 30px;

  .line {
    display: none;
    background: #3794fc;
    width: 100%;
    height: 4px;
    position: absolute;
    left: 50%;
    bottom: -10px;
    transform: translate(-50%, -50%);
    border-radius: 100px;
  }

  &.active,
  &:hover {
    color: #3794fc;
    border: none;
    background: none;
  }

  &.active {
    .line {
      display: block;
    }
  }
`;

export default function CampaignEditMenu({ selectedItem, campaignId, history }) {
  return (
    <Styled>
      <ButtonStyled
        type="primary"
        onClick={(e) => {
          e.stopPropagation();
          history.push(`/${campaignId}`);
        }}
        className={classNames(selectedItem === 'campaignInfo' && 'active')}
      >
        Campaign Info
        <span className="line" />
      </ButtonStyled>
      <ButtonStyled
        type="primary"
        onClick={(e) => {
          e.stopPropagation();
          history.push(`/${campaignId}/affectedItems`);
        }}
        className={classNames(selectedItem === 'affectedItems' && 'active')}
      >
        Affected Items
        <span className="line" />
      </ButtonStyled>
      <ButtonStyled
        type="primary"
        onClick={(e) => {
          e.stopPropagation();
          history.push(`/${campaignId}/requiredItems`);
        }}
        className={classNames(selectedItem === 'requiredItems' && 'active')}
      >
        Required Items
        <span className="line" />
      </ButtonStyled>
    </Styled>
  );
}

CampaignEditMenu.propTypes = {
  selectedItem: PropTypes.string,
  campaignId: PropTypes.string,
  history: PropTypes.object,
};

CampaignEditMenu.defaultProps = {
  selectedItem: '',
  campaignId: '',
  history: {},
};
